import {
  ArticlePageContentProps,
  ContentMenuItem,
} from '~containers/ArticlePage/ArticlePageContent/ArticlePageContent.types';

export const mapContentToMenu = (
  content: NonNullable<ArticlePageContentProps['content']>,
) => {
  return content.reduce<Array<ContentMenuItem>>((menu, block) => {
    if (block.titleMenu && block.hash) {
      menu.push({
        id: block.id,
        __component: block.component,
        title: block.titleMenu,
        hash: block.hash,
      });
      return menu;
    }
    return menu;
  }, []);
};
